export default "__VITE_ASSET__DD7m9xO1__"